import { create } from "zustand";

export interface UserContext {
  id: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  picture: string | undefined;
  tier: 'FREE' | 'PAID' | undefined;
}

export interface UserContextStore {
  userContext: UserContext | null;
  setUserContext: (userContext: UserContext | null) => void;
}

export const useUserContextStore = create<UserContextStore>((set) => ({
  userContext: null,
  setUserContext: (userContext) => set({ userContext }),
}));

export const updateUserContext = (user: UserContext) => {
  if (useUserContextStore.getState().userContext?.email === user.email)
    return;

  useUserContextStore.getState().setUserContext(user);
  // Save to localStorage
  localStorage.setItem("userContext", JSON.stringify(user));
};

// Rehydrate user context from localStorage
export const rehydrateUserContext = () => {
  const storedUser = localStorage.getItem("userContext");
  if (storedUser) {
    const userContext = JSON.parse(storedUser);
    useUserContextStore.getState().setUserContext(userContext);
  }
};

// Clear user context on logout
export const clearUserContext = () => {
  useUserContextStore.getState().setUserContext(null);
  localStorage.removeItem("userContext");
  localStorage.removeItem("firebaseToken");
  localStorage.removeItem("firebaseUser");
  window.location.reload();
};
